module.exports = __webpack_public_path__ + "img/talkicon1.8151db5e.png";